import { render } from "./TagsModalNew.vue?vue&type=template&id=28003820&scoped=true"
import script from "./TagsModalNew.vue?vue&type=script&lang=js"
export * from "./TagsModalNew.vue?vue&type=script&lang=js"

import "./TagsModalNew.vue?vue&type=style&index=0&id=28003820&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28003820"]])

export default __exports__